export enum BenachrichtigungTyp {
    info = 1,
    warning = 2,
}
